import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { productSearchRead } from "../../DataApi/products/productSearchRead";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";

const initialState = {
  productsList: [],
  loading: "idle",
  error: null,
};

const fetchProductData = createAsyncThunk(
  "product/fetchData",
  async ({
    company_id,
    context,
    pagination = { limit: PAGINATION_DEFAULT_LIMIT, offset: 0 },
    search = { query: "", type: "" },
    sort = { type: "", dir: "asc" },
  }) => {
    try {
      let response = await productSearchRead({
        context,
        company_id,
        pagination,
        search,
        sort,
      });
      response = JSON.parse(response) || {};
      return {
        records: response?.result?.records || [],
        length: response?.result?.length || 0,
      };
    } catch (error) {
      console.error("An error occurred in searchRead:", error);
    }
  }
);

const ProductSlice = createSlice({
  name: "product",
  initialState,
reducers:{  updateProductQuantity: (state, action) => {
    const { productId, inventoryItems } = action.payload;
    if (Array.isArray(inventoryItems)) {
      const totalQuantity = inventoryItems.reduce((total, item) => total + item.inventory_quantity, 0);
      const index = state.productsList.findIndex((product) => product.id === productId);
      if (index !== -1) {
        state.productsList[index].qty_available = totalQuantity;
      }
    }
  },
  setProductList: (state, action) => {
    state.productsList = action.payload;
  },
},

  extraReducers: (builder) => {
    builder
      .addCase(fetchProductData.pending, (state) => {
        state.loading = "pending";
        state.error = null;
      })
      .addCase(fetchProductData.fulfilled, (state, action) => {
        state.productsList = action?.payload?.records || [];
        state.length = action?.payload?.length || 0;
        state.loading = "succeed";
        state.error = null;
      })
      .addCase(fetchProductData.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

export const {updateProductQuantity} = ProductSlice.actions;
export const productAction = {
  ...ProductSlice.actions,
  fetchProductData,
 
  

};

export default ProductSlice.reducer;
